import { FormType, UserRole } from '../../utils/enums';

export type AdministrationRoutes = 'menu' | 'table' | 'staff' | 'sponsor';

export const HeaderTitle = (type: FormType, translate: (data: string) => string | any[], target: AdministrationRoutes, role?: UserRole) => {
  if (role && role !== UserRole.BACKOFFICE) {
    return type === FormType.NEW ? translate(`pages.${target}.new`).toString() : translate(`pages.${target}.edit`).toString();
  } else return '';
};
